/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteMetadataUrl = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_METADATA_URL">
      <SelectionSet
        name="deleteMetadata_url"
        alias="deleteMetadataUrl"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteMetadataUrl: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
